import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Group 1538231948" }, [
      _createElementVNode("path", {
        id: "Vector 5386",
        d: "M0 6H12",
        stroke: "#1C1D1F",
        "stroke-width": "2"
      }),
      _createElementVNode("path", {
        id: "Vector 5387",
        d: "M6 0L6 12",
        stroke: "#1C1D1F",
        "stroke-width": "2"
      })
    ], -1)
  ]))]))
}
export default { render: render }